var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"relative",class:_vm.aspectRatioClass},[_c('img',{staticClass:"absolute h-full w-full object-cover",attrs:{"src":_vm.link,"alt":_vm.alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }